import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaGooglePlay,
  FaApple,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaTwitterSquare
} from "react-icons/fa";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Top Section */}
      <div className="footer-top container">

        {/* About Section */}
        <div className="footer-section about">
          <h3>About Us</h3>
          <p>
            We are a fashion-forward eCommerce store committed to providing
            quality and style. Shop with confidence and discover new trends every day.
          </p>

          <div className="footer-contact">
            <FaEnvelope /> contact@mystore.com
          </div>

          <div className="footer-contact">
            <FaPhoneAlt /> +1 (123) 456-7890
          </div>

          <div className="footer-contact">
            <FaMapMarkerAlt /> 123 Fashion St, Trendy City, 12345
          </div>
        </div>

        {/* Customer Service */}
        <div className="footer-section">
          <h3>Customer Service</h3>
          <ul>
            <li>Help Center</li>
            <li>Returns</li>
            <li>Shipping Info</li>
            <li>Track Order</li>
            <li>FAQs</li>
          </ul>
        </div>

        {/* Shop */}
        <div className="footer-section">
          <h3>Shop</h3>
          <ul>
            <li>Vegitables</li>
            <li>Fruits</li>
            <li>Combo packs</li>
            <li>Sale</li>
          </ul>
        </div>

        {/* Social & App */}
        <div className="footer-section social-app">
          <h3>Follow Us</h3>

          <div className="social-icons">
            <FaFacebook />
            <FaTwitterSquare />
            <FaInstagram />
          </div>

          <h4>Download Our App</h4>
          <div className="app-buttons">
            <button className="app-btn google">
              <FaGooglePlay /> Google Play
            </button>

            <button className="app-btn apple">
              <FaApple /> App Store
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>
          <a href="/">Privacy Policy</a> |{" "}
          <a href="/">Terms & Conditions</a> |{" "}
          <a href="/">Sitemap</a>
        </p>

        <p>© {new Date().getFullYear()} MyStore. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;